
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M22.53 0L10.323 1.78v9.007h12.206V0zM0 3.226v7.639h9.213V1.96L0 3.226zm0 8.578v7.639l9.213 1.29v-8.929H0zm10.323.119v8.955l12.206 1.729V11.923H10.323z","fill":"#FFF"}})])
      }
    
      }
    